import React, { useState, useEffect } from "react";
import { useQuery } from "@apollo/react-hooks";
import { httpClient } from "settings/apolloClient";
import styled from "styled-components";
// import ShipmentReportResult from "./ShipmentReportResult";
import { ShipmentModal } from "./ShipmentModal";
import CONCRETE_SHIPMENTS_QUERY from "./graphql/concreteShipmentsQuery";
import CONCRETE_SHIPMENT_REPORT_QUERY from "./graphql/concreteShipmentReportQuery";

const formatLocalTime = (datetime) => {
  if (!datetime) return "";
  const date = new Date(datetime);
  return `${String(date.getHours()).padStart(2, "0")}h${String(date.getMinutes()).padStart(2, "0")}`;
};

const formatLocalDate = (datetime) => {
  if (!datetime) return "";
  const date = new Date(datetime);
  return `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()}`;
};

const formatDecimal = (value) => {
  if (!value) return "";
  return parseFloat(value).toFixed(1);
};

const formatVolume = (volume) => {
  if (!volume) return "";
  return `${formatDecimal(volume)} m³`;
};

const TableHeader = [
  { code: "code", label: "Código", width: "50%" },
  { code: "startTime", label: "Início", width: "15%" },
  { code: "loadingEndTime", label: "Fim", width: "15%" },
  { code: "quantity", label: "Quantidade", width: "20%" },
];

const TableContainer = styled.div`
  width: 80%;
  margin: 0 auto;
`;

const Table = styled.table`
  width: 100%;
`;

const TableRow = styled.tr`
  width: 100%;
  border-bottom: 1px solid #cfd1d3;
  cursor: pointer;

  &.selected {
    background-color: #edeff2;
  };

  &:hover {
    background-color: #cfd1d3;
  };
`;

const SingleLine = styled.td`
  padding: 14px 16px;
  font-size: 16px;
  color: #8798AD;
  text-align: left;
  font-weight: bold;
`;

// Formula column should be a column with 2 lines,
// the first line should be the formula code it should have a bigger font size and a bold font weight,
// the second line should be the slump and fck, it should have a smaller font size and a normal font weight
const DoubleLine = styled.td`
  padding: 14px 16px;
  font-size: 13px;
  color: #8798AD;
  text-align: left;
`;

const Header = styled.th`
  width: 100%;
  background-color: #fff;
  padding-top: ${props => (!props.isMobile ? "22px" : "8px")};
  padding-bottom: ${props => (!props.isMobile ? "22px" : "8px")};
  padding-left: ${props => (!props.isMobile ? "16px" : "6px")};
  padding-right: ${props => (!props.isMobile ? "16px" : "6px")};
  text-align: ${props => (props.center ? "center" : "left")};
`;


export const ShipmentListTable = () => {
  const [limit] = useState(10);
  const [offset] = useState(0);
  const [orderBy] = useState("desc");
  const { data } = useQuery(CONCRETE_SHIPMENTS_QUERY, {
    variables: {
      limit,
      offset,
      orderBy,
    },
    client: httpClient,
    fetchPolicy: "network-only",
  });
  const [selectedRowCode, setSelectedRowCode] = useState(null);

  const [modalOpen, setModalOpen] = useState(false);

  const toggleRow = (id, code) => {
    setSelectedRowCode(prev => (prev === code ? null : code));
    setModalOpen(true);
  };

  const clearRow = () => {
    setSelectedRowCode(null);
    setModalOpen(false);
  };

  return (
    <TableContainer>
      {data && (
        <React.Fragment>
          <h1
            style={{
              marginTop: "20px",
              marginBottom: "20px",
              marginLeft: "10px",
            }}
          >
            Últimos Carregamentos
          </h1>
          <Table>
            <thead>
              <tr>
                {TableHeader.map(({ code, label, width }) => (
                  <Header key={code} style={{ width }}>
                    {label}
                  </Header>
                ))}
              </tr>
            </thead>
            <tbody
              style={{
                cursor: "pointer",
              }}
            >
              {data && data.concreteShipments.map((shipment) => (
                <React.Fragment key={shipment.code}>
                  <TableRow
                    onClick={() => toggleRow(shipment.id, shipment.code)}
                  >
                    <DoubleLine>
                      <div
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                      >
                        {shipment.code}
                      </div>
                      <div>{`Lacre: ${shipment.sealNumber}`}</div>
                    </DoubleLine>
                    <DoubleLine>
                      <div
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                      >
                        {formatLocalTime(shipment.startTime)}
                      </div>
                      <div>{formatLocalDate(shipment.startTime)}</div>
                    </DoubleLine>
                    <DoubleLine>
                      <div
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                      >
                        {formatLocalTime(shipment.loadingEndTime)}
                      </div>
                      <div>{formatLocalDate(shipment.loadingEndTime)}</div>
                    </DoubleLine>
                    <SingleLine>
                      {formatVolume(shipment.quantity)}
                    </SingleLine>
                  </TableRow>
                </React.Fragment>
              ))}
            </tbody>
          </Table>
        </React.Fragment>
      )}
      {modalOpen && (
        <ShipmentModal
          code={selectedRowCode}
          isOpen={modalOpen}
          close={clearRow}
        />
      )}
    </TableContainer>
  );
};
